<template>
  <div class="">
    <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix"> 
      <el-form-item label="请选择门店：" class="tinp" style="margin: 0 !important">
	      <el-select @change="selectchange" filterable value-key="storecode" v-model="store.storename" clearable placeholder="请选择门店" style="width:100%;" auto-complete="off">
	        <el-option v-for="item in storeList" :key="item.storecode" :label="item.storename" :value="item"></el-option>
	      </el-select>
	  </el-form-item>
     <el-form-item label="单据标识：" class="tinp">
            <el-select v-model="flag" placeholder="请选择菜单类型" class="" @change="selectchange2"  style="width:100%;">
              <el-option v-for="item in menutypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
    </el-form-item>
	  <el-form-item label="创建日期：" class="tinp searchtime searchtime2" :class="{iconshow:showicon}">
          <el-date-picker @change="selectchange2" value-format="yyyy-MM-dd" v-model="time" type="date" placeholder="选择日期" @mouseover.native="cleandataicon" @mouseout.native="cleandataicon">
          </el-date-picker>
      </el-form-item>
      <el-button type="primary" class="" size="small" icon="el-icon-search" @click="getlist">搜索</el-button> 
    </el-form>
    <!-- tablebox kucun tableboxprint width:100% -->
    <div class="">
      <table style="min-width: 1146px;word-break:break-word，white-space: -moz-pre-wrap;table-layout:fixed;">
       <!--  <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;">
          <th style="" v-for="head in tableHeads">{{ head.label }}</th> 
        </tr> 
      -->
        <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px">
          <th style=""><div style="width:133px">发送门店</div></th> 
          <th style=""><div style="width:132px">方法名称</div></th> 
          <th style=""><div style="width:362px;margin: 0 auto;">参数值</div></th> 
          <th style=""><div style="width:151p;margin: 0 auto;">返回值</div></th> 
          <th style=""><div style="width:303px;margin: 0 auto;text-align:center"><span>日志信息</span></div></th> 
          <th style=""><div style="width:62px">单据标识</div></th> 
        </tr>
        <tr v-for="(item,index) in tableList" :key="index">
          <td v-for="head in tableHeads" style="border: 1px solid #56B8AA;min-height: 45px;padding:0 10px">
            <div style="min-height: 45px;" v-if="head.key!='parameter'"><span>{{item[head.key]}}</span></div>
            <div style="word-break:break-all;word-wrap:break-word;" v-else-if="head.key!='message'"><span>{{item[head.key]}}</span></div>
            <div style="word-break:break-all" v-else><span>{{item[head.key]}}</span></div>
          </td> 
        </tr>
        <tr v-if="count==0">
          <td colspan="11" style="border:0;background-color: rgba(239,240,244,1);color:#909399">暂无数据</td>
        </tr>
      </table>
    </div>
    <!-- fenye start -->
    <div class="block" style="text-align: center;margin:20px auto ">
      <span><el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count"></el-pagination></span>
    </div>
    <!-- fenye end -->
    <div class=""  v-loading.fullscreen.lock="fullscreenLoading"></div>
    <!-- 弹窗 start --> 
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag2" :butmsg="butmsg2" :butflag = "butflag2" @modelmsg="returnMsg2"></MessageModel> 
  </div>
</template>
<script> 
import { getElementsByClassName } from '../../../static/js/getDomByClassName.js'  
export default {
  name: '',
  data() {
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      time:'', 
      flag:'Y', 
      width: 0, //动态宽度
      page: 1,
      pageSize: 10,
      count: 0,
      showicon: '',
      conditions: {
        input1: '', //货位
        input2: '', //关键字
      },
      menutypeList:[
          {
             label:'成功',
             value:'Y'
          },
          {
            label:'失败',
            value:'N'
          }
        ],
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      storeList: [],
      store: {
        storecode: '', //门店编码
        storename: '' //门店名称
      },
      positionList: [],
      fullscreenLoading: true,
      userInfo: {}, 
      tableHeads: [
      	// {
       //    label: '门店编码',
       //    key: 'sender'
       //  },
        {
          label: '发送门店',
          key: 'sendername'
        },
        {
          label: '方法名称',
          key: 'interfacemethod'
        },
        {
          label: '参数值',
          key: 'parameter'
        },
        {
          label: '返回值',
          key: 'returnvalue'
        },
        {
          label: '日志信息',
          key: 'message'
        },
        {
          label: '单据标识',
          key: 'flag'
        } 
      ],
      tableList: [],
      InterfacePath: ''
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pageSize");
    sessionStorage.removeItem("kucunlist");
    sessionStorage.removeItem("clocationid");
    sessionStorage.removeItem("Keyword");
    sessionStorage.removeItem("count");
   // console.log("清除session");
  },
  methods: {
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
            // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
               // console.log("---参数！！！----"+JSON.stringify(this.reqparams)); 
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    }else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      //  this.$alert('门店请购单信息删除失败', '失败信息', {
                      //   confirmButtonText: '确定'
                      // });
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow =false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了';
                    // this.$alert('获取接口失败', '失败信息', {
                    //     confirmButtonText: '确定'
                    // });
                    console.log(err);
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    returnMsg2(flag) {

      this.modelFlag = false;
      
       if (flag) {
       // console.log("---进来了！！！----" + this.methodName);
         
      }
    },
    selectchange2(value){
        this.page = 1;
      //  console.log("打印标识："+this.flag+"打印value:"+value);
        this.getlist();
    },
    getstore() {
      //获取数据接口 
      this.$http.post(this.InterfacePath + '/selectStore', { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          var stores = res.data.resultList;
          this.storeList = [];
          for (var i = stores.length - 1; i > -1; i--) {
            this.storeList.push({ storename: stores[i].storename, storecode: stores[i].storecode });
          }
         // console.log("打印货位" + JSON.stringify(this.storeList));
        } else if (res.data.status == '-1') {
         // console.log("-----暂无数据！！！");
        } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }

      }, (err) => {
        this.modelFlag = true;
        this.msgShow =false;
        this.methodName = 'message';
        this.msg = '连接获取门店信息接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
        console.log(err);
      });
    },
    selectchange(value) { 
        this.page = 1;
        this.store.storecode = value.storecode;
        this.store.storename = value.storename; 
        this.getlist();
    },
    cleandataicon() {
      // console.log("打印时间-=-=-=-"+this.list.dcountdate);
      if (this.time != '') {
        // console.log("打印时间-=-=-=-"+this.list.dcountdate);
        this.showicon = !this.showicon;
      }
      if (this.time == null) {
        this.showicon = false;
      }
    }, 
    dellist(index, msg1, msg2) {
      this.$confirm('此操作将永久删除该调整单，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var reqparam = {
          storecode: this.userInfo.storecode, //门店编码
          coutstockorgid: this.userInfo.coutstockorgid, //仓库编码
          clocationid: msg1,
          materialcode: msg2
        };
        this.$http.post(this.utilpath + '/applybill', reqparam).then((res) => {
          // this.$http.post('api/applybill',reqparam).then((res)=>{
          // this.$http.post('ktnapi/applybill',reqparam,{emulateJSON:true}).then((res)=>{
          if (res.data.status == '0') {
            if (this.tableList.length > 1) {
              this.tableList.splice(index, 1);
            }
            this.count = this.tableList.length;
            sessionStorage.setItem("kucunlist", JSON.stringify(this.conditions));
            sessionStorage.setItem("count", this.count);
            this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'succcess'
            });
          } else if (res.data.status == '-1') {

          } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.$message({
              showClose: true,
              message: '删除失败!',
              type: 'error'
            });
          }
        }, (err) => {
          this.$message({
            showClose: true,
            message: '命令提交失败!',
            type: 'error'
          });
          console.log(err);
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    init() {
      var users = JSON.parse(window.localStorage.getItem("userInfo"));
      if (users != null) {
        this.userInfo = users;
        this.fullscreenLoading =false;
      }
      this.width = document.documentElement.clientWidth - 200; 

      this.getstore();
      this.getlist();
      // }else{
      this.page = parseFloat(sessionStorage.getItem("page"));
      this.pageSize = parseFloat(sessionStorage.getItem("pageSize"));   
    }, 
    handleSizeChange(val) {
     // console.log(`每页 ${val} 条`);
      this.pageSize = val;
       this.page=1; 
      this.getlist();
    //  console.log(this.pageSize);
    },
    handleCurrentChange(val) {
    //  console.log(`当前页: ${val}`);
      this.page = val;
     // console.log("当前页---:" + this.page);
     // console.log("页码----:" + this.pageSize);
      this.getlist();

      //搜索参数
      // var reqparam = {
      //   storecode: this.userInfo.storecode, //门店编码  
      //   time: this.time, //门店编码  
      //   pageNum: this.page,
      //   pageSize: this.pageSize,
      // };
      // this.$http.post(this.utilpath + '/selectLogin', reqparam, { emulateJSON: true,_timeout:600 }) 
      //   .then((res) => { 
      //     this.tableList = res.data.resultList; 
      //     this.count = res.data.countNum;
      //     console.log("打印数据长度：" + this.count);
      //   }, (err) => {

      //   }); 
      // sessionStorage.setItem("page", this.page);
      // sessionStorage.setItem("pageSize", this.pageSize);
      // sessionStorage.setItem("count", this.count);
    },
    getlist() { //获取数据
      this.fullscreenLoading = true;
      //搜索参数 
      var reqparam = {
        storecode: this.store.storecode, //门店编码  
        time: this.time, //商品名称
        flag:this.flag,
        pageNum: this.page,
        pageSize: this.pageSize,
      };
     // console.log("reqpara-=-==m" + JSON.stringify(reqparam))
      this.$http.post(this.utilpath + '/selectLogin', reqparam, { emulateJSON: true,_timeout:600 }).then((res) => { 
        	if(res.data.status =='0'){ 		 
              this.fullscreenLoading = false;        
        		  this.tableList = res.data.resultList;  
		          this.count = res.data.countNum;
        	}else if(res.data.status =='-1'){
            this.fullscreenLoading = false;
            this.tableList =[];
            this.count = res.data.countNum;
            this.$message({
            showClose:true,
            message:'暂无数据！',
            type:'info'
          });
          } else if(res.data.status == '9'){
              this.fullscreenLoading = false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else{
              this.fullscreenLoading = false;
              this.modelFlag = true;
        		  this.msgShow = true;
		          this.methodName = 'message';
		          this.msg = res.data.message;
		          this.butflag =false;
		          this.butmsg='知道了';
        	}
         // console.log("打印数据长度：" + this.count);
        }, (err) => {
            this.fullscreenLoading = false;
            this.msgShow =false;
        	  this.modelFlag = true;
	          this.methodName = 'message';
	          this.msg = '连接获取盘点单接口失败'+err;
	          this.butflag =false;
	          this.butmsg='知道了';
        }); 
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pageSize", this.pageSize);
      sessionStorage.setItem("count", this.count);
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/system/loginfo.vue